import ContentWithBanners from './ContentWithBanners'

export default ContentWithBanners
